<template>
	<div
			class="modal"
			id="media-cropper"
			tabindex="-1"
			role="dialog"
			aria-labelledby="media-cropper"
			aria-hidden="true"
			data-backdrop="static"
			data-keyboard="false"
	>
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">
				<div class="block block-themed block-transparent mb-0">
					<div class="block-header bg-primary-dark">
						<h3 class="block-title">Image Cropper</h3>
						<div class="block-options">
							<button
									type="button"
									class="btn-block-option"
									data-dismiss="modal"
									aria-label="Close"
							>
								<i class="fa fa-fw fa-times"></i>
							</button>
						</div>
					</div>
					<div class="block-content">
						<!-- Toolbar -->
						<div class="block mb-2">
							<div class="block-content text-center">
								<!--                                <div class="btn-group push">-->
								<!--&lt;!&ndash;                                    title="Set drag mode to move"&ndash;&gt;-->
								<!--                                    <button type="button" class="js-tooltip btn btn-sm btn-primary" data-toggle="cropper" @click="toolBarAction('setDragMode', 'move')" >-->
								<!--                                        <i class="fa fa-arrows-alt"></i>-->
								<!--                                    </button>-->
								<!--&lt;!&ndash;                                    title="Set drag mode to crop"&ndash;&gt;-->
								<!--                                    <button type="button" class="js-tooltip btn btn-sm btn-primary" data-toggle="cropper" @click="toolBarAction('setDragMode', 'crop')">-->
								<!--                                        <i class="fa fa-crop"></i>-->
								<!--                                    </button>-->
								<!--                                </div>-->
								<div class="btn-group push">
									<!--                                    title="Zoom In"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											@click="toolBarAction('zoom', '0.1')"
									>
										<i class="fa fa-search-plus"></i>
									</button>
									<!--                                    title="Zoom Out"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											@click="toolBarAction('zoom', '-0.1')"
									>
										<i class="fa fa-search-minus"></i>
									</button>
								</div>
								<div class="btn-group push">
									<!--                                    title="Rotate Left"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											@click="toolBarAction('rotate', '-45')"
									>
										<i class="fa fa-undo-alt"></i>
									</button>
									<!--                                    title="Rotate Right"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											@click="toolBarAction('rotate', '45')"
									>
										<i class="fa fa-redo-alt"></i>
									</button>
								</div>
								<div class="btn-group push">
									<!--                                    title="Flip Horizontal"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											@click="toolBarAction('scaleX', scaleX)"
									>
										<i class="fa fa-arrows-alt-h"></i>
									</button>
									<!--                                    title="Flip Vertical"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											@click="toolBarAction('scaleY', scaleY)"
									>
										<i class="fa fa-arrows-alt-v"></i>
									</button>
								</div>
								<div class="btn-group push">
									<!--                                    title="Set Aspect Ratio"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											:disabled="settings && settings.limitAR != '9:4'"
											@click="toolBarAction('setAspectRatio', '2.25')"
									>9:4
									</button>
									<!--                                    title="Set Aspect Ratio"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											:disabled="settings && settings.limitAR != '16:9'"
											@click="toolBarAction('setAspectRatio', '1.7777777777777777')"
									>16:9
									</button>
									<!--                                    title="Set Aspect Ratio"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											:disabled="settings && settings.limitAR != '3:2'"
											@click="toolBarAction('setAspectRatio', '1.5')"
									>3:2
									</button>
									<!--                                    title="Set Aspect Ratio"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											:disabled="settings && settings.limitAR != '4:3'"
											@click="toolBarAction('setAspectRatio', '1.3333333333333333')"
									>4:3
									</button>
									<!--                                    title="Set Aspect Ratio"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											:disabled="settings && settings.limitAR != '1:1'"
											@click="toolBarAction('setAspectRatio', '1')"
									>1:1
									</button>
									<!--                                    title="Set Aspect Ratio"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											:disabled="settings && settings.limitAR != '2:3'"
											@click="toolBarAction('setAspectRatio', '0.6666666666666666')"
									>2:3
									</button>
									<!--                                    title="Set Aspect Ratio"-->
									<button
											type="button"
											class="js-tooltip btn btn-sm btn-primary"
											data-toggle="cropper"
											:disabled="settings && settings.limitAR != '4:9'"
											@click="toolBarAction('setAspectRatio', '0.4444444444')"
									>4:9
									</button>
								</div>
								<!--                                title="Set Aspect Ratio"-->
								<button
										type="button"
										class="js-tooltip btn btn-sm btn-primary push"
										data-toggle="cropper"
										:disabled="settings && settings.limitAR != 'NaN'"
										@click="toolBarAction('setAspectRatio', 'NaN')"
								>Free
								</button>
								<!--                                <div class="btn-group push">-->
								<!--&lt;!&ndash;                                    title="Clear"&ndash;&gt;-->
								<!--                                    <button type="button" class="js-tooltip btn btn-sm btn-primary" data-toggle="cropper" @click="toolBarAction('clear')">-->
								<!--                                        <i class="fa fa-times"></i>-->
								<!--                                    </button>-->
								<!--&lt;!&ndash;                                    title="Crop"&ndash;&gt;-->
								<!--                                    <button type="button" class="js-tooltip btn btn-sm btn-primary" data-toggle="cropper" @click="toolBarAction('crop',)">-->
								<!--                                        <i class="fa fa-check"></i>-->
								<!--                                    </button>-->
								<!--                                </div>-->
							</div>
						</div>
						<!-- END Toolbar -->

						<!-- Image Cropper -->
						<div class="block">
							<div class="block-content" v-if="chosenFile">
								<div class="row items-push">
									<div class="col-xl-6">
										<h4 class="border-bottom pb-2">Cropper</h4>
										<div id="js-img-cropper-div"></div>
									</div>
									<div class="col-xl-6">
										<h4 class="border-bottom pb-2">Preview</h4>
										<div class="overflow-hidden mb-2">
											<div
													class="js-img-cropper-preview mx-auto overflow-hidden"
													style="height: 200px;"
											></div>
										</div>
										<div class="overflow-hidden mb-2">
											<div
													class="js-img-cropper-preview mx-auto overflow-hidden"
													style="height: 150px;"
											></div>
										</div>
										<div class="overflow-hidden mb-2">
											<div
													class="js-img-cropper-preview mx-auto overflow-hidden"
													style="height: 100px;"
											></div>
										</div>
									</div>
								</div>
							</div>
							<div v-else>
								<h4>Something went wrong</h4>
							</div>
						</div>
						<!-- END Image Cropper -->
					</div>
					<div class="block-content block-content-full text-right border-top">
						<button
								type="button"
								class="btn btn-sm btn-light"
								@click.prevent.stop="cancelCrop(true)"
						>Cancel
						</button>
						<button
								class="btn btn-sm btn-success"
								v-if="chosenFile && chosenFile.url"
								@click.prevent.stop="saveCrop"
						>Save
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		props: {
			chosenFile: Object,
			settings: {
				type: Object,
				default() {
					return {
						limitAR: 'NaN'
					}
				}
			},
			timezone: String,
		},
		data() {
			return {
				cropper: null,
				scaleX: -1,
				scaleY: -1,
				cropTimeout: null
			};
		},
		methods: {
			setUpCropper() {
				const vm = this;
				$("#js-img-cropper-div").append(
					'<img id="js-img-cropper" class="img-fluid w-100" src="' +
					(this.chosenFile.originalURL
						? this.chosenFile.originalURL
						: this.chosenFile.url) +
					'" alt="photo">'
				);
				const $image = document.getElementById("js-img-cropper");

				// fix quality in case of big images
				if (this.chosenFile.originalURL && this.chosenFile.originalURL.indexOf("q_auto") === -1)
					this.chosenFile.originalURL = this.chosenFile.originalURL.replace(
						"/upload/",
						"/upload/q_auto/"
					);

				// Set Options
				const options = {
					aspectRatio: this.settings.limitAR == 'NaN' ? this.settings.limitAR : ((this.settings.width && this.settings.height) ? (this.settings.width / this.settings.height) : (this.settings.limitAR ? eval(this.settings.limitAR.replace(':', '/')) : 4 / 3)),
					autoCrop: true,
					preview: ".js-img-cropper-preview",
					zoomOnWheel: false,
					viewMode: 0,
				};

				if ((!this.settings.width && !this.settings.height) || this.settings.startFullCrop) {
					// this.settings.width = $($image).width();
					// this.settings.height = $($image).height();

					delete this.settings.width;
					delete this.settings.height;
					delete this.settings.startFullCrop;
					options.autoCropArea = 1;
				}

				options.data = this.settings;
				Cropper.setDefaults(options);

				// make sure the image is loaded all the way
				$("#js-img-cropper").on("load", () => {
					console.log("Image done loading");
					// Init Image Cropper
					vm.cropper = new Cropper($image, {
						crop: function (e) {
							// e.detail contains all data required to crop the image server side
							// You will have to send it to your custom server side script and crop the image there
							// Since this event is fired each time you set the crop section, you could also use getData()
							// method on demand. Please check out https://fengyuanchen.github.io/cropperjs/ for more info
							vm.chosenFile.cropperSettings = {
								...vm.chosenFile.cropperSettings,
								...e.detail,
							};

							clearTimeout(vm.cropTimeout);
							vm.cropTimeout = setTimeout(() => {
								vm.saveCrop(false);
								console.log('Saving Crop');
							}, 500)
						},
					});
				});
			},
			toolBarAction(method, option = false) {
				// Method selection
				switch (method) {
					case "zoom":
						this.cropper.zoom(option);
						break;
					case "setDragMode":
						this.cropper.setDragMode(option);
						break;
					case "rotate":
						this.cropper.rotate(option);
						break;
					case "scaleX":
						this.cropper.scaleX(option);
						this.scaleX = -this.scaleX;
						break;
					case "scaleY":
						this.cropper.scaleY(option);

						this.scaleY = -this.scaleY;
						break;
					case "setAspectRatio":
						this.cropper.setAspectRatio(option);
						break;
					case "crop":
						this.cropper.crop();
						break;
					case "clear":
						this.cropper.clear();
						break;
				}
			},
			saveCrop(cancel=true) {
				if (!this.chosenFile.originalURL)
					this.chosenFile.originalURL = this.chosenFile.url;

				// if it's a cloudinary image then change the url
				if (this.chosenFile.originalURL.indexOf("cloudinary.com") > -1) {
					let i = this.chosenFile.originalURL.lastIndexOf("/upload/");

					// let aspectRatio = this.chosenFile.width / this.chosenFile.height;
					let url = this.chosenFile.originalURL.substring(0, i + 8);
					url += "x_" + Math.round(this.chosenFile.cropperSettings.x) + ",";
					url += "y_" + Math.round(this.chosenFile.cropperSettings.y) + ",";
					url += "w_" + Math.round(this.chosenFile.cropperSettings.width) + ",";
					url += "h_" + Math.round(this.chosenFile.cropperSettings.height) + ",";
					if (this.chosenFile.cropperSettings.rotate)
						url +=
							"a_" + Math.round(this.chosenFile.cropperSettings.rotate) + ",";

					if (this.chosenFile.cropperSettings.scaleX < 0)
						// horizontal flip, cloudinary is opposite cropper js
						url += "a_hflip,";
					if (this.chosenFile.cropperSettings.scaleY < 0)
						// vertical flip, cloudinary is opposite cropper js
						url += "a_vflip,";

					url += "c_crop";
					// if( this.chosenFile.cropperSettings.scaleX !=1 || this.chosenFile.cropperSettings.scaleY != 1 ) {
					//     url += '/w_'+Math.round(100*this.chosenFile.cropperSettings.scaleX)+',';
					//     url += '/h_'+Math.round(100*this.chosenFile.cropperSettings.scaleY)+',';
					//     url += 'c_scale';
					// }

					this.chosenFile.url =
						url + this.chosenFile.originalURL.substring(i + 7);
				}

				this.$emit("file-cropped", this.chosenFile);
				if( cancel )
					this.cancelCrop();
			},
			cancelCrop(goBack=false) {
        const modals = document.querySelectorAll('.modal.show');
        if (modals.length)
          document.body.classList.add('modal-open')

				$("#media-cropper").modal("hide");
				if (this.cropper) this.cropper.destroy();

				$("#js-img-cropper").remove();
				$(".modal").css("overflow-y", "auto"); // fix bootsrap scroll bug
				if( goBack )
					this.$emit("go-back", true);
			},
		},
		mounted() {
			const self = this;
			$("#media-cropper").on("hidden.bs.modal", function () {
				self.cancelCrop();
			});
			this.$forceUpdate();
		},
		computed: {},
		watch: {
			// chosenFile: function(val) {
			//     console.log(val);
			//
			//     if( this.cropper )
			//         this.cropper.destroy();
			//
			//     // wait for the modal to appear
			//     setTimeout(() => {
			//         this.setUpCropper();
			//     }, 250);
			// },
		},
	};
</script>

<style>
</style>